import { CART_FRAGMENT } from '@/graphql/fragments/cart'
import { CountryConfig } from '../../../types/countryConfig'
import { CONTACT_FRAGMENT } from '@/graphql/fragments/contact'
import { COUNTRY_CONFIG_FRAGMENT } from '@/graphql/fragments/countryConfig'
import { SOCIETY_FRAGMENT } from '@/graphql/fragments/society'
import { Contact } from '@/types/contact'
import { SocietyType } from '@/types/society'
import { gql } from '@apollo/client'
import { Cart } from '@/types/cart'

interface ContactWithUserPresence extends Contact {
  userPresent: boolean
}

export interface RestorePageDataType {
  contact: ContactWithUserPresence
  countryConfig: CountryConfig
  society: SocietyType
  currentCart: Cart
  domiciliation: {
    paid: boolean
  }
}

export const RESTORE_PAGE_QUERY = gql`
  query restorePage {
    countryConfig {
      ...CountryConfigFragment
    }
    society {
      ...SocietyFragment
    }
    contact {
      ...ContactFragment
      userPresent
    }
    currentCart {
      ...CartFragment
    }
    domiciliation {
      paid
    }
  }
  ${CONTACT_FRAGMENT}
  ${SOCIETY_FRAGMENT}
  ${COUNTRY_CONFIG_FRAGMENT}
  ${CART_FRAGMENT}
`
